<template>
  <div class="login-page">
	<user-agent-info>
	</user-agent-info>
    <div class="login-wrap">
      <el-col :class="translateLeft" :span="10">

        <div v-show="isLogin">
          <div class="logo">
            <img :src="$store.getters.metadata.icon"  v-bind:style="{height: $store.getters.metadata.iconType === 'rectangle'? '24px' : '48px'}"/>
            <div class="title">
              <a>
                <span>{{$store.getters.metadata.title.first}}</span><span class="subtitle">{{$store.getters.metadata.title.second}}</span>
              </a>
            </div>
          </div>

          <div class="login-form">
            <el-form :model="loginForm" :rules="loginRules" ref="loginForm" status-icon>

                <el-row :gutter="20">
	              	<el-col :span="6">
	              		<el-form-item prop="areaCode">
	              			<el-select v-model="loginForm.areaCode" placeholder="请选择">
	              				<el-option value="86" label="86"></el-option>
	              			</el-select>
			              </el-form-item>
	              	</el-col>
	              	<el-col :span="18">
	              		<el-form-item prop="username">
              	            <el-input v-model="loginForm.username"></el-input>
                        </el-form-item>
	              	</el-col>
	              </el-row>

              <el-form-item prop="password">
              	<el-input v-model="loginForm.password" type="password"></el-input>
              </el-form-item>

              <el-row :gutter="20" v-if="isNeedRandomCode">
                  <el-col :span="14">
                      <el-form-item prop="randomcode">
			              	<el-input v-model="loginForm.randomcode" placeholder="请输入验证码"></el-input></el-form-item>
                  </el-col>
                  <el-col :span="10">
                      <el-button id="getLoginCode" type="warning" @click="getLoginCode">获取验证码</el-button>
	              	</el-col>
              </el-row>

              <el-form-item class="btn">
              	<el-row :gutter="20">
                  <el-col :span="12">
                    <el-button :loading="loading" type="primary" @click="handleLogin('loginForm')">{{$t('login.btn')}}</el-button>
                  </el-col>
                  <el-col :span="12">
                    <el-button @click="wrapSwitch(false,false,true)" type="info" plain>{{$t('login.register')}}</el-button>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>

          <div class="login-footer">
            <el-col :span="12">
              <el-checkbox v-model="remember" name="type">{{$t('login.remember')}}</el-checkbox>
            </el-col>
            <el-col class="forgetpwd" :span="12">
              <span @click="wrapSwitch(false,true,false)">{{$t('login.forgetpwd')}}</span>
            </el-col>
          </div>
        </div>

          <div v-show="isForget">
          	<div class="title forgetwrap-title">
	            <a>
	              <span>{{$store.getters.metadata.title.first}}</span><span class="subtitle">{{$store.getters.metadata.title.second}}</span>
	            </a>
	          </div>
	          <div class="forget-form">
	            <el-form :model="forgetForm" :rules="forgetRule" ref="forgetForm" status-icon>
	              <el-row :gutter="20">
	              	<el-col :span="6">
	              		<el-form-item prop="areaCode">
	              			<el-select v-model="forgetForm.areaCode" placeholder="请选择">
	              				<el-option value="86" label="86"></el-option>
	              			</el-select>
			              </el-form-item>
	              	</el-col>
	              	<el-col :span="18">
	              		<el-form-item prop="mobile">
			              	<el-input v-model="forgetForm.mobile" placeholder="请输入手机号"></el-input>
			              </el-form-item>
	              	</el-col>
	              </el-row>
	              <el-row :gutter="20">
	              	<el-col :span="14">
	              		<el-form-item prop="randomcode">
			              	<el-input v-model="forgetForm.randomcode" placeholder="请输入验证码"></el-input>
			              </el-form-item>
	              	</el-col>
	              	<el-col :span="10">
	              		<el-button id="getForgetCode" type="warning" @click="getForgetCode">获取验证码</el-button>
	              	</el-col>
	              </el-row>
	              <el-form-item prop="newPassword">
	              	<el-input v-model="forgetForm.newPassword" placeholder="请输入新密码" type="password"></el-input>
	              </el-form-item>
	              <el-form-item prop="confirmPassword">
	              	<el-input v-model="forgetForm.confirmPassword" placeholder="再次输入密码" type="password"></el-input>
	              </el-form-item>
	              <el-form-item class="btn">
	                <el-row :gutter="20">
	                  <el-col :span="12">
	                    <el-button @click="wrapSwitch(true,false,false)" type="primary">{{$t('login.forget_back')}}</el-button>
	                  </el-col>
	                  <el-col :span="12">
	                    <el-button @click="forgetHandle" type="primary">{{$t('login.forget_btn')}}</el-button>
	                  </el-col>
	                </el-row>
	              </el-form-item>
	            </el-form>
	          </div>
          </div>

          <div v-show="isRegister">
          	<div class="title forgetwrap-title">
	            <a>
	              <span>{{$store.getters.metadata.title.first}}</span><span class="subtitle">{{$store.getters.metadata.title.second}}</span>
	            </a>
	          </div>
	          <div class="forget-form">
	            <el-form :model="registerForm" :rules="registerRule" ref="registerForm" status-icon>
	              <el-row :gutter="20">
	              	<el-col :span="6">
	              		<el-form-item prop="areaCode">
	              			<el-select v-model="registerForm.areaCode" placeholder="请选择">
	              				<el-option value="86" label="86"></el-option>
	              			</el-select>
			              </el-form-item>
	              	</el-col>
	              	<el-col :span="18">
	              		<el-form-item prop="mobile">
			              	<el-input v-model="registerForm.mobile" placeholder="请输入手机号"></el-input>
			              </el-form-item>
	              	</el-col>
	              </el-row>
	              <el-row :gutter="20">
	              	<el-col :span="14">
	              		<el-form-item prop="randomcode">
			              	<el-input v-model="registerForm.randomcode" placeholder="请输入验证码"></el-input>
			              </el-form-item>
	              	</el-col>
	              	<el-col :span="10">
	              		<el-button id="getRegisterCode" type="warning" @click="getRegisterCode">获取验证码</el-button>
	              	</el-col>
	              </el-row>
	              <el-form-item prop="password">
	              	<el-input v-model="registerForm.password" placeholder="请输入密码" type="password"></el-input>
	              </el-form-item>
	              <el-form-item prop="confirmPassword">
	              	<el-input v-model="registerForm.confirmPassword" placeholder="再次输入密码" type="password"></el-input>
	              </el-form-item>
	              <el-form-item class="btn">
	                <el-row :gutter="20">
	                  <el-col :span="12">
	                    <el-button @click="wrapSwitch(true,false,false)" type="primary">{{$t('login.forget_back')}}</el-button>
	                  </el-col>
	                  <el-col :span="12">
	                    <el-button @click="registerHandle" type="primary">{{$t('login.register')}}</el-button>
	                  </el-col>
	                </el-row>
	              </el-form-item>
	            </el-form>
	          </div>
          </div>

      </el-col>

      <el-col :class="translateRight" :span="14">
        <div :style="`background: url(${$store.getters.metadata.pic});background-size: cover`" class="wallpaper"></div>
      </el-col>
    </div>
  </div>
</template>

<script>
import langselect from '@/components/langselect'
import storage from '@/utils/storage'
import axios from 'axios'
import { setToken, removeToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import qs from 'qs'
import UserAgentInfo from '../../components/userAgentInfo/index'

export default {
  name: 'login',
  components: {
		UserAgentInfo,
  	langselect
  },
  mounted() {
  	this.$store.dispatch('closeAllView')
  },
  data() {
  	var validForgetMobile = (rule, value, callback)=>{
		  if(value === ''){
		  	callback(new Error("手机号不能为空"));
		  }else{
		  	if(this.forgetForm.areaCode == "86"){
		  		var reg = /^1[0-9][0-9]{9}$/;
			  	if(!reg.test(value)){
			  		callback(new Error("手机号格式不正确"));
			  	}
		  	}
		  	callback();
		  }
		}
		var validForgetNewPassword = (rule,value,callback)=>{
		  if(value === ''){
		  	callback(new Error("新密码不能为空"));
		  }else{
		  	if (this.forgetForm.confirmPassword !== '') {
		      this.$refs.forgetForm.validateField('confirmPassword');
		    }
		  	callback();
		  }
		}
		var validForgetConfirmPassword = (rule, value, callback) => {
		  if (value === '') {
		    callback(new Error('确认密码不能为空'));
		  } else if (value !== this.forgetForm.newPassword) {
		    callback(new Error('两次输入密码不一致!'));
		  } else {
		    callback();
		  }
		}
		var validRegisterMobile = (rule, value, callback)=>{
		  if(value === ''){
		  	callback(new Error("手机号不能为空"));
		  }else{
		  	if(this.registerForm.areaCode == "86"){
		  		var reg = /^1[0-9][0-9]{9}$/;
			  	if(!reg.test(value)){
			  		callback(new Error("手机号格式不正确"));
			  	}
		  	}
		  	callback();
		  }
		}
		var validRegisterPassword = (rule,value,callback)=>{
		  if(value === ''){
		  	callback(new Error("新密码不能为空"));
		  }else{
		  	if (this.registerForm.confirmPassword !== '') {
		      this.$refs.registerForm.validateField('confirmPassword');
		    }
		  	callback();
		  }
		}
		var validRegisterConfirmPassword = (rule, value, callback) => {
		  if (value === '') {
		    callback(new Error('确认密码不能为空'));
		  } else if (value !== this.registerForm.password) {
		    callback(new Error('两次输入密码不一致!'));
		  } else {
		    callback();
		  }
		}
    return {
      lang: this.$store.state.app.language,
      loginForm: {
        username: storage.get('loginUser') || '',
        password: '',
        randomcode: '',
        areaCode: '86'
      },
      loginRules: {
        username: [{ trigger: 'blur', required: true, message:'账号不能为空' }],
        password: [{ trigger: 'blur', required: true, message:'密码不能为空' },
                             { trigger: 'blur', min: 6, max: 16, message:'密码长度在6到16之间' }],
        randomcode: [{ trigger: 'blur', required: true, message:'验证码不能为空' }]
      },
      remember: true,
      loading: false,
      switchLeft: false,
      switchRight: false,
      isLogin: true,
      isForget:false,
      isRegister:false,
      isNeedRandomCode:false,
      forgetForm: {
      	areaCode: '86',
        mobile: '',
        randomcode:'',
        newPassword: '',
        confirmPassword: ''
      },
      forgetRule:{
      	mobile:[{ trigger: 'blur',validator: validForgetMobile }],
      	randomcode:[{ trigger: 'blur', required: true, message:'验证码不能为空' }],
      	newPassword:[{ trigger: 'blur',validator: validForgetNewPassword },
      							 { trigger: 'blur', min: 6, max: 16, message:'密码长度在6到16之间' }],
      	confirmPassword:[{ trigger: 'blur',validator: validForgetConfirmPassword }]
      },
      registerForm:{
      	areaCode: '86',
        mobile: '',
        randomcode:'',
      	password:'',
      	confirmPassword: ''
      },
      registerRule:{
      	mobile:[{ trigger: 'blur',validator: validRegisterMobile }],
      	randomcode:[{ trigger: 'blur', required: true, message:'验证码不能为空' }],
      	password:[{ trigger: 'blur', min: 6, max: 16, message:'密码长度在6到16之间' },
      						{ trigger: 'blur', validator: validRegisterPassword }],
      	confirmPassword:[{ trigger: 'blur',validator: validRegisterConfirmPassword }]
      }
    }
  },
  computed: {
    translateLeft() {
      return {
        'translate-left': true,
        'login-col': true,
        'switch-left': this.switchLeft
      }
    },
    translateRight() {
      return {
        'translate-right': true,
        'login-col': true,
        'switch-right': this.switchLeft
      }
    }
  },
  methods: {
    wrapSwitch(isLogin,isForget,isRegister) {
      this.switchLeft = !this.switchLeft
      this.switchRight = !this.switchRight
      setTimeout(() => {
        this.isLogin = isLogin
        this.isForget = isForget
        this.isRegister = isRegister
        if(isLogin){
        	this.$refs["loginForm"].resetFields();
        	this.loginForm.username = storage.get('loginUser');
        }else if(isForget){
        	this.$refs["forgetForm"].resetFields();
        }else if(isRegister){
        	this.$refs["registerForm"].resetFields();
        }
      }, 300)
    },
    handleLogin(formName) {
      this.loading = true
      var thiz = this;
      this.$refs[formName].validate(async valid => {
        if (valid) {
        	let { username, password,randomcode } = this.loginForm
          this.remember
              ? storage.set('loginUser', username)
			  : storage.set('loginUser', '')
					var appid = this.$store.getters.appid;
					// appid = 19987635;
          var param = qs.stringify({appid,username,password,randomcode})
          axios.post(this.$store.getters.getApiValue+'/login.do',param).then(function (response) {
						thiz.$store.dispatch('setSliderState', 'collapse')
          	thiz.loading = false
					  var data = response.data;
					  if(data.status == "200"){
					   	thiz.$message.success("登录成功");
					   	setToken(data.data.token)
		          Cookies.set("srs_nickname",data.data.nickname);
		          Cookies.set("srs_avatar",data.data.avatar);
		          Cookies.set("srs_username",data.data.username);
                  storage.set("srs_menus",data.data.menus);
		          storage.set('visitedViews', []);
					    thiz.$router.push({ path: '/' })
					}else if(data.status=="NeedVerificationCodeException"){
                        thiz.isNeedRandomCode=true;
                        thiz.$message.error(data.message);
                    }else{
                        thiz.isNeedRandomCode=false; 
                        thiz.$message.error(data.message);
                    }
					}).catch(function (error) {
						thiz.loading = false
					  console.log(error);
					  thiz.$message.error("系统异常,请与管理员联系!");
					});
        } else {
          this.loading = false
          this.$message.error("填写不完整或格式不正确，请确认！")
        }
      })
    },
    forgetHandle() {
    	var thiz = this;
    	this.$refs["forgetForm"].validate((valid) => {
        if (valid) {
        	var appid = this.$store.getters.appid;
        	var areaCode = this.forgetForm.areaCode;
        	var mobile = this.forgetForm.mobile;
        	var code = this.forgetForm.randomcode;
        	var password = this.forgetForm.newPassword;
        	var param = qs.stringify({appid,areaCode,mobile,code,password})
		    	axios.post(this.$store.getters.getApiValue+'/reset.do',param).then(function (response) {
					  var data = response.data;
					  if(data.status == "200"){
					    	thiz.$message.success("修改成功");
					    	storage.set('loginUser', thiz.registerForm.mobile)
					    	thiz.wrapSwitch(true,false,false)
					  }else{
					    	thiz.$message.error(data.message);
					  }
					}).catch(function (error) {
					  console.log(error);
					  thiz.$message.error("系统异常,请与管理员联系!");
					});
        }else {
		      this.$message.error("填写不完整或格式不正确，请确认！")
		      return false;
		    }
      });
    },
    registerHandle() {
    	var thiz = this;
      this.$refs["registerForm"].validate((valid) => {
        if (valid) {
        	var areaCode = "86";
        	var appid= this.$store.getters.appid;
        	var username = this.registerForm.mobile;
        	var randomcode = this.registerForm.randomcode;
        	var password = this.registerForm.password;
        	var param = qs.stringify({appid,areaCode,username,randomcode,password})
		    	axios.post(this.$store.getters.getApiValue+'/signup.do',param).then(function (response) {
					    var data = response.data;
					    if(data.status == "200"){
					    	thiz.$message.success("注册成功");
					    	storage.set('loginUser', thiz.registerForm.mobile)
					    	thiz.wrapSwitch(true,false,false)
					    }else{
					    	thiz.$message.error(data.message);
					    }
					  }).catch(function (error) {
					    console.log(error);
					    thiz.$message.error("系统异常,请与管理员联系!");
					  });
        } else {
          this.$message.error("填写不完整或格式不正确，请确认！")
          return false;
        }
      });
    },
    getLoginCode(){
        this.$refs.loginForm.validateField('username');
    	this.setBtnTimer(this.loginForm.areaCode,this.loginForm.username,document.getElementById("getLoginCode"));
    },
    getForgetCode(){
    	this.$refs.forgetForm.validateField('mobile');
    	this.setBtnTimer(this.forgetForm.areaCode,this.forgetForm.mobile,document.getElementById("getForgetCode"));
    },
    getRegisterCode(){
    	this.$refs.registerForm.validateField('mobile');
    	this.setBtnTimer(this.registerForm.areaCode,this.registerForm.mobile,document.getElementById("getRegisterCode"));
    },
    setBtnTimer(areaCode,mobile,btnObj){
    	if(mobile === "" || mobile === null){
    		this.$message.error("手机号不能为空");
			  return;
    	}
    	if(areaCode == "86"){
    		var reg = /^1[0-9][0-9]{9}$/;
			  if(!reg.test(mobile)){
			  	this.$message.error("手机号格式有误");
			  	return;
			  }
    	}
    	btnObj.disabled = true;
    	this.getCodeByApi(areaCode,mobile);
    	var timeCount = 60;
    	clearInterval(timer);
    	var timer = setInterval(function(){
          if(timeCount>0){
            timeCount--;
            btnObj.innerHTML = timeCount +"s后重发";
            btnObj.style.backgroundColor = "#CCCCCC";
      			btnObj.style.borderColor = "#CCCCCC";
          }else{
            btnObj.innerHTML ="获取验证码";
            btnObj.disabled = false;
            btnObj.style.backgroundColor = "#e6a23c";
            btnObj.style.borderColor = "#e6a23c";
            clearInterval(timer);
          }
      },1000);
    },
    getCodeByApi(areaCode,mobile){
			var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/code.do',{
  			params:{
                appid:thiz.$store.getters.appid,
  			    areaCode:areaCode,
  				mobile:mobile
  			}
  		}).then(function (response) {
		    var data = response.data;
		    if(data.status == "200"){
		    	thiz.$message.success("发送验证消息成功");
		    }else{
		    	thiz.$message.error(data.message);
		    }
		  }).catch(function (error) {
		    console.log(error);
		    thiz.$message.error("系统异常,请与管理员联系!");
		  });
    }
  }
}
</script>

<style lang="stylus">
.forget-form,
.login-form
  .el-form-item__content
    line-height 40px
  .el-input__inner
    padding-top: 2px;
    height 40px
    line-height 40px

.btn button
    width: 100%
    padding 12px 20px

</style>

<style lang="stylus" scoped>
@import "../../assets/styl/variables.styl"

.login-col
  height 100%

.login-page
  display flex
  justify-content center
  align-items center
  position absolute
  height 100%
  width 100%
  .lang
    position absolute
    right 59px
    top 24px
  .svg-github
    position absolute
    right 29px
    top 25px
  .translate-left
  .translate-right
    will-change auto
    transform translateX(0px)
    transition transform .6s ease-in-out
  .switch-left
    transform translateX(525px)
  .switch-right
    transform translateX(-375px)

.login-wrap
  overflow hidden
  width 900px
  height 450px
  background white
  border-radius 4px
  transform translateY(-10px)
  box-shadow 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04)

  .logo
    padding-top 26px
    text-align center

  .title
    font-weight bold
    color main-color
    padding-top 8px
    font-size 22px

    a
      cursor cell
    a:before
      content '['
      opacity 0
      margin-right 10px
      transform translateX(-10px)
      transition transform .2s, opacity .2s

    a:after
      content ']'
      opacity 0
      margin-left 10px
      transform translateX(10px)
      transition transform .2s, opacity .2s

    a:hover:before
    a:hover:after
      opacity 1
      transform translateX(0)

    .subtitle
      color sub-color

  .forgetwrap-title
    padding-top 30px
    padding-left 15px

  .forget-form
    padding 20px 30px 30px
    padding-bottom 0

  .login-form
    padding 30px
    padding-bottom 0

  .login-footer
    padding 0 30px
    .forgetpwd
      text-align right
      span
        cursor pointer
        font-size 14px
        font-weight 500
        color #606266

  .wallpaper
    width 100%
    height 100%
    position relative
</style>
